/**
 * Returns true if the symbolObj is defined and contains a symbol, false otherwise
 * @param {any }symbolObj
 * @returns {boolean}
 */
export function isSymbolReady(symbolObj) {
    return symbolObj && symbolObj.symbol;
}
/**
 * Returns true if events are filled and available
 * @param {any }eventList
 * @returns {boolean}
 */
export function areEventsReady(eventList) {
    return eventList && eventList.eventList && Object.keys(eventList.eventList).length > 0;
}
/**
 * Returns true if the passed parameter contains all required methods, false otherwise
 * @param {any} dataHandler
 * @returns {boolean}
 */
export function isDataHandlerValid(dataHandler) {
    //data handler is mandatory. This is the minimum a chart needs to be able to work, as explained in the @ChartContentDataHandler class
    return dataHandler !== null && dataHandler !== undefined && dataHandler.getHistoricData;
}
/**
 * Returns true if the passed parameter contains all requirements, false otherwise
 * @param {any} storageHandler
 * @returns {boolean}
 */
export function isStorageHandlerValid(storageHandler) {
    //storage handler is not mandatory but if passed, it needs to be valid
    return (storageHandler &&
        storageHandler.retrieveSettingsDrawings &&
        storageHandler.saveSettings &&
        storageHandler.saveDrawings &&
        storageHandler.removeSettingsDrawings);
}
/**
 * Returns true if the passed markers handler is valid, false otherwise
 * @param {any} markersHandler
 * @returns {boolean}
 */
export function isMarkersHandlerValid(markersHandler) {
    //markersHandler handler is not mandatory but if passed, it needs to be valid
    return markersHandler && markersHandler.translate && markersHandler.getMarkers;
}
//# sourceMappingURL=check.js.map